// extracted by mini-css-extract-plugin
export default {"container":"DocsHeader_container__7NZPN","title":"DocsHeader_title__wkI5z","buttons":"DocsHeader_buttons__Yckf5"};